import axios, { isAxiosError } from "axios";
import { useEffect, useState } from "react"
import Loadingwrapper from "../../component/LoadingWrapper";
import Pagination from "../wishlist/Pagination";


const LIMIT = 200;
const HashtagImages = ({ geography, startDate, endDate, hashTag }) => {

  const [images, setImages] = useState([])
  const [totalImages, setTotalImages] = useState(0)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const abortController = new AbortController()
    getImages(abortController.signal)
    return () => {
      abortController.abort()
    }
  }, [geography, startDate, endDate, hashTag, page])

  const getImages = async (signal) => {
    setLoading(true)
    try {
      const response = await axios.get(`/api/hashtag/images?from=${startDate}&to=${endDate}&geography=${geography}&page=${page}&hashtag=${hashTag}`, { signal })
      setTotalImages(response.data.count)
      setImages(response.data.images)
      setLoading(false)
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }
  }

  return <div className="h-[80vh] w-[80vw]">
    <h3 className="text-center text-xl "><span className=" font-medium text-blue-500">#{hashTag}</span> images {totalImages ? <span>({totalImages})</span> : null}</h3>

    <Pagination totalpages={Math.ceil(totalImages / LIMIT)} currentPage={page || 1} changePage={setPage} paginationDisabled={false} />
    <hr className="my-2" />
    <Loadingwrapper loading={loading} className="h-full">
      <div className="flex w-full flex-wrap">

        {images.map(image => <div key={image.mediaId} className="w-1/4 p-1 mb-2">
          <div className="flex justify-center">
            <img loading="lazy" src={image.imageUrl} className="h-80 w-auto" />
          </div>
          <div className="px-2">
            <p>{new Date(image.timeStamp).toDateString()}</p>
            <p><a href={'https://www.instagram.com/' + image.username} target="_blank" className="text-blue-400 hover:text-blue-500">{image.username}</a></p>
            <p><a href={image.postUrl} target="_blank" className="text-blue-400 hover:text-blue-500">Post URL</a></p>
          </div>
        </div>)}
      </div>
    </Loadingwrapper>

  </div>

}

export default HashtagImages
